// Vue Checkbox component
// Matches the styling and functionality of checkbox.twig
export const VueCheckbox = {
  name: 'VueCheckbox',
  props: {
    modelValue: {
      type: [Boolean, Array, String, Number],
      default: false
    },
    name: {
      type: String,
      required: true
    },
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false
    },
    alignTop: {
      type: Boolean,
      default: true
    },
    extraAttrs: {
      type: String,
      default: ''
    },
    // For HTML labels (like route names with formatting)
    htmlLabel: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  computed: {
    isChecked() {
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.includes(this.value);
      }
      return this.modelValue;
    }
  },
  methods: {
    handleChange(event) {
      const checked = event.target.checked;

      if (Array.isArray(this.modelValue)) {
        let newValue = [...this.modelValue];
        if (checked) {
          if (!newValue.includes(this.value)) {
            newValue.push(this.value);
          }
        } else {
          newValue = newValue.filter(item => item !== this.value);
        }
        this.$emit('update:modelValue', newValue);
      } else {
        this.$emit('update:modelValue', checked);
      }
    }
  },
  template: `
    <label class="checkbox-styling" :class="{ 'checkbox-align-top': alignTop }">
      <input
        type="checkbox"
        :name="name"
        :value="value"
        :class="size ? 'checkbox-' + size : ''"
        :checked="isChecked"
        @change="handleChange"
        v-bind="$attrs"
      >
      <span class="checkmark"></span>
      <span v-if="!htmlLabel && !$slots.default">[[ label ]]</span>
      <span v-else-if="htmlLabel && !$slots.default" v-html="label"></span>
      <slot v-else></slot>
    </label>
  `
};

export default VueCheckbox;
